
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class AcceptedMovesBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class AcceptedMovesBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    return {
      id:          data.id,
      seq:         data.index,
      name:        `${data.text}`,
      hasChildren: data.children.length > 0,
      isExpanded:  false,
      type:        'accepted-moves',
      children:    data.children,
      parent:      args.parent,
      kids:        data.kids,
      tags:        data.tags,
      label:       data.label,
      pkey:        data.pkey,
      text:        data.text,

    };

  }
}
